module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.7-85.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.7.md
// module id = 503
// module chunks = 338